
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './Contact.css'
import ContactForm from './Contactform';
import pic1 from "../pics/pattern1.jpg"
import React from 'react';


function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='contact'
    >
         <Modal.Header className='modal-head' closeButton>
       
      </Modal.Header>

      <div className='contact-main'>
        <div>
            <img alt="contact" className='contact-img' src={pic1}></img>
        </div>
        <div className='contact-form'>

    <ContactForm></ContactForm>

        </div>
      </div>
   


    </Modal>
  );
}

export default MyVerticallyCenteredModal;




